import { HTMLAttributes } from "react";

const Text = (prop: HTMLAttributes<HTMLSpanElement>)=>{
    return <span
    {...prop}
    >{prop.children}</span>
}

export default Text;